import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import { useShouldFetchBulkAndShipping } from '@/vdp/VehicleDetailsContainer/hooks';
import { useEventCorrelationId } from '~/context/common/StaticContext';
import { useIsLoggedIn, useUserLocation } from '~/context/common/UserContext';
import {
  useDeliveryPickup,
  useSoonestRoute
} from '~/context/vdp/DeliveryPickupContext';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import { useGetVehicleId } from '~/context/vdp/VehicleContext';
import {
  fetchTransitChargeAnonymous,
  fetchTransitChargeAuthenticated
} from '~/services/vdp';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetTransitRoute() {
  const {
    transitRoute: { setData, setError, setLoading, setLoaded }
  } = useContext(UserVehicleContext);
  const deliveryPickup = useDeliveryPickup();
  const isLoggedIn = useIsLoggedIn();
  const routeId = useSoonestRoute()?.routeId;
  const { state: stateAbbreviation, zip } = useUserLocation();
  const eventCorrelationId = useEventCorrelationId();
  const vehicleId = useGetVehicleId();
  const shouldFetchBulkAndShipping = useShouldFetchBulkAndShipping();

  const shouldFetch = Boolean(
    shouldFetchBulkAndShipping && stateAbbreviation && vehicleId && zip
  );

  useEffectWithController(
    controller => {
      if (!deliveryPickup.isLoaded || !shouldFetch) return;

      setLoading();

      (isLoggedIn
        ? fetchTransitChargeAuthenticated(
            controller,
            { routeId, stateAbbreviation, vehicleId },
            eventCorrelationId
          )
        : fetchTransitChargeAnonymous(
            controller,
            { deliveryZip5: zip, routeId, vehicleId },
            eventCorrelationId
          )
      )
        .then(quote => {
          setData({
            activityType: quote.transferType,
            charge: quote.deliveryCharge,
            routeId: quote.routeId
          });
        })
        .catch(
          generateErrorLogger(
            'Get transit charge',
            {},
            { callback: setError, controller }
          )
        );
    },
    [
      deliveryPickup.isLoaded,
      eventCorrelationId,
      isLoggedIn,
      routeId,
      setData,
      setError,
      setLoaded,
      setLoading,
      shouldFetch,
      stateAbbreviation,
      vehicleId,
      zip
    ]
  );
}
